import { type JwtPayload, jwtDecode } from 'jwt-decode';

export const isJwtExpired = (token: string) => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    if (!decoded.exp) {
      return true;
    }

    const MS_PER_MINUTE = 60000;
    const safeGap = 5 * MS_PER_MINUTE;

    const actualExpiredMs = decoded.exp * 1000;

    /** Consider token invalid 5 minutes before actual expiration time for safety
     * (e.g. expired access token might have only a few seconds left before expiring, but get used for request,
     * causing API to return 'UNAUTHORIZED' => the client unexpectedly logs user out. */
    const expired = new Date(actualExpiredMs - safeGap);
    const now = new Date();

    return expired < now;
  } catch (err) {
    console.error(err);

    return true;
  }
};
